import React, { useState } from 'react';
import styled from 'styled-components';
import { PencilSquareIcon } from '@heroicons/react/24/outline';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect, useCallback } from 'react';  
import { useParams, useNavigate } from 'react-router-dom';
import { getAccessToken } from '../react-queries/queries';
import { findMyBooksByReadTo, findMyBooksByScriptTo, countMyBooksByReadToOrScriptTo, findMyBooksByReadFrTo, findMyBooksByScriptFrTo } from '../api/BookcaseApi';
import { processApiResponse } from '../common/errorMessage';
import LoadingOverlay from '../components/LoadingOverlay';
import BookDetailPage from './BookDetailPage';
import NupilBookDetailPage from './NupilBookDetailPage';
import { FaTimes } from 'react-icons/fa';
import { stringFrDate } from '../common/utils';
import BookCoverImage from '../components/BookCoverImage';




const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;


const BookDetailModal = ({bookId, onClose, selectedTab, onModified }) => {
  return (
    <Modal>
      <ModalHeader>
        <ModalTitle>상세 보기</ModalTitle>
        <ModalCloseButton onClick={()=>{onClose();}}>
          <FaTimes />
        </ModalCloseButton>
      </ModalHeader>
      <ModalContent>
        {selectedTab === Noobook 
        ? <BookDetailPage propBookId={bookId} onClose={onClose} onModified={onModified} /> 
        : <NupilBookDetailPage propBookId={bookId} onClose={onClose} onModified={onModified} />}
      </ModalContent>
    </Modal>
  )
};





const ViewType = {
  ViewEndDate: 0,//종료일 보기
  ViewAll: 1,//전체보기
};

const months = [
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'
];
const daysKor = ['일', '월', '화', '수', '목', '금', '토'];

const Noobook = "누북";
const Noopill = "누필";
const LeftArrow = 1;
const RightArrow = 2;

/*/ 샘플 기록 데이터
const sampleRecords = {
  '2025-05-07': [
    {
      title: '하버드 새벽 4시반',
      author: '웨이슈잉',
      publisher: '정민미디어',
      period: '2025. 05. 01 ~ 05. 19',
      image: '/book_sample1.jpeg',
      memoCount: 8,
    },
    {
      title: '이중 하나는 거짓말',
      author: '김애란',
      publisher: '문학동네',
      period: '2025. 05. 15 ~ 05. 19',
      image: '/book_sample2.jpeg',
      memoCount: 5,
    },
  ],
  // ... 다른 날짜 샘플
};
*/
// 독서종료 날짜 샘플 데이터 (등록된 책들의 독서종료 날짜)
//const bookEndDates = [
//  { date: 15, title: '하버드 새벽 4시반' },
//  { date: 19, title: '이중 하나는 거짓말' },
//  { date: 25, title: '고전이 답이다' },
//  { date: 30, title: 'CHANGING FATE' },
//];

//const today = new Date(2025, 4, 7); // 2025년 5월 7일 기준

let hrefPushed = null;
export default function RecordCalendarPage() {
  const [selectedTab, setSelectedTab] = useState('누북');
  
  

  const { setShowBack,  showBack, setOnBookRegistered, onBookRegistered } = useNoobookContext();
  const { date } = useParams();
  const [selectedDate, setSelectedDate] = useState(new Date(date));
  const [selectedYear, setSelectedYear] = useState(selectedDate.getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(selectedDate.getMonth());
  const [viewType, setViewType] = useState(ViewType.ViewAll);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [bookMap, setBookMap] = useState(new Map());
  const [memoCntMap, setMemoCntMap] = useState(new Map());
  const [selBookId, setSelBookId] = useState(null);
  const [showBookDetailModal, setShowBookDetailModal] = useState(false);
  const [showYearMonthPicker, setShowYearMonthPicker] = useState(false);
  const [isBookDetailModified, setIsBookDetailModified] = useState(false);
  const [tempSelectedYear, setTempSelectedYear] = useState(selectedYear);
  const [tempSelectedMonth, setTempSelectedMonth] = useState(selectedMonth);
  const yearRefs = React.useRef({});
  const monthRefs = React.useRef({});

  const navigate = useNavigate();



 

  useEffect(() => {
    const prevShowBack = showBack;
    const prevOnBookRegistered = onBookRegistered;
    setShowBack(true);
    setOnBookRegistered(() => () => {
      loadRecords();
    });
    //loadRecords(selectedTab);
    return () => {
      setShowBack(prevShowBack);
      setOnBookRegistered(() => prevOnBookRegistered);
    };
  }, []);

  // 달력 데이터 생성 (서울 타임존 적용)
  const firstDay = new Date(selectedYear, selectedMonth, 1);
  const lastDay = new Date(selectedYear, selectedMonth + 1, 0);
  const startDay = firstDay.getDay();
  const daysInMonth = lastDay.getDate();


  const loadRecords = async () => {
    setLoading(true);
    try{
      const {accessToken} = await getAccessToken();
      let response;
      console.log('tabName:', selectedTab);
      console.log('firstDay:', firstDay, firstDay.toISOString());
      if (selectedTab===Noobook) {
        if (viewType===ViewType.ViewEndDate) {
          response = await findMyBooksByReadTo(accessToken, firstDay.toISOString(), lastDay.toISOString());
        } else {
          response = await findMyBooksByReadFrTo(accessToken, firstDay.toISOString(), lastDay.toISOString());
        }
      } else {
        if (viewType===ViewType.ViewEndDate) {
          response = await findMyBooksByScriptTo(accessToken, firstDay.toISOString(), lastDay.toISOString());
        } else {
          response = await findMyBooksByScriptFrTo(accessToken, firstDay.toISOString(), lastDay.toISOString());
        }
      }
      console.log('response:', response);
      const processedResponse = processApiResponse(response);
    
      if (!processedResponse.success) {
        setError(processedResponse.errorMessage);
        return;
      }
      const bMap = new Map();
      setBookMap(bMap);
      if (viewType===ViewType.ViewEndDate) {
        processedResponse.data.forEach(book => {
          const dateTo = new Date(selectedTab===Noobook ? book.readTo : book.scriptTo).getDate();
          const books = bMap.get(dateTo) || [];
          bMap.set(dateTo, [...books, book]);
          //console.log('books:', books, ', readTo:', readTo);
        });
      } else {
        processedResponse.data.forEach(book => {
          const dateFr = new Date(selectedTab===Noobook ? book.readFr : book.scriptFr);//.getDate();
          const dateTo = new Date(selectedTab===Noobook ? book.readTo : book.scriptTo);//.getDate();
          console.log('book:', book, ', firstDay:', firstDay, ', lastDay:', lastDay);
          let date = new Date(firstDay);
          for(date.setDate(firstDay.getDate()); date <= lastDay; date.setDate(date.getDate()+1)) {
            console.log('date:', date, ', dateFr:', dateFr, ', dateTo:', dateTo);
            if(dateFr <= date && dateTo >= date) {
              const books = bMap.get(date.getDate()) || [];
              console.log('books:', books, ', date.getDate():', date.getDate());
              bMap.set(date.getDate(), [...books, book]);
            }
          }
        });
      }

      console.log('BookMap:', bMap);

      const memoCntResponse = await countMyBooksByReadToOrScriptTo(accessToken, firstDay.toISOString(), lastDay.toISOString());
      console.log('memoCntResponse:', memoCntResponse);
      const processedMemoCntResponse = processApiResponse(memoCntResponse);
      if (!processedMemoCntResponse.success) {
        setError(processedMemoCntResponse.errorMessage);
        return;
      }
      const memoCntMap = new Map();
      setMemoCntMap(memoCntMap);
      processedMemoCntResponse.data.forEach(memoCnt => {
        memoCntMap.set(memoCnt.bookUserId, memoCnt.memoCnt);
      });
      console.log('MemoCntMap:', memoCntMap);
    } catch (error) {
      console.error('책 메모 정보 로드 중 오류:', error);
      //setError('네트워크 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }

  }

  useEffect(() => {
    loadRecords();
  }, [selectedYear, selectedMonth, selectedTab, viewType]);

  useEffect(() => {
    if (showYearMonthPicker) {
      // 선택된 년도로 스크롤
      setTimeout(() => {
        if (yearRefs.current[tempSelectedYear]) {
          yearRefs.current[tempSelectedYear].scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
        if (monthRefs.current[tempSelectedMonth]) {
          monthRefs.current[tempSelectedMonth].scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      }, 100);
    }
  }, [showYearMonthPicker, tempSelectedYear, tempSelectedMonth]);

  // 날짜별 기록 있는 날짜(점 표시용)
  console.log('bookMap:', bookMap);

  const onTabBtnClick = useCallback((tab) => {
    setSelectedTab(tab);
   // loadRecords(tab);
  }, [selectedTab]);

  const onMonthSelectBtnClick = useCallback((direction) => {
    if (direction === LeftArrow) {
      if (selectedMonth === 0) {
        setSelectedYear(selectedYear - 1);
        setSelectedMonth(11);
      } else {
        setSelectedMonth(selectedMonth - 1);
      }
      
    } else {
      if (selectedMonth === 11) {
        setSelectedYear(selectedYear + 1);
        setSelectedMonth(0);
      } else {
        setSelectedMonth(selectedMonth + 1);
      }
    }
    setSelectedDate(new Date(selectedYear, selectedMonth, 1));
    //loadRecords(selectedTab);
  }, [selectedDate, selectedYear, selectedMonth]);

  const popupBookDetail = (bookId) => {
    setSelBookId(bookId);
    setShowBookDetailModal(true);
  };

  const handleBookDetailClose = (modified) => {
    setShowBookDetailModal(false);
    if(modified) {
      loadRecords();
      setIsBookDetailModified(false);
    }
  };

  const handleBookDetailModified = (modified) => {
    if(modified) {
      setIsBookDetailModified(true);
    }
  };

  // 뒤로가기 버튼으로 모달 닫기
  
  useEffect(() => {
    
    const handlePopState = (event) => {
      //alert('handlePopState1');
      if (showBookDetailModal) {
        //alert('handlePopState2');
        event.preventDefault();
        handleBookDetailClose(false);
        if(hrefPushed == window.location.href) {
          hrefPushed = null;
        }
      } 
    };

    // 모달이 열려있을 때만 history state를 push하고 이벤트 리스너 등록
    if (showBookDetailModal) {
      hrefPushed = window.location.href;
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handlePopState);
        return () => {
        window.removeEventListener('popstate', handlePopState);
        if(hrefPushed === window.location.href) {
          //window.history.back();
          hrefPushed = null;
        } 
      };
    } 
  }, [showBookDetailModal]);

  // 달력 날짜 배열 생성
  const calendarCells = [];
  for (let i = 0; i < startDay; i++) calendarCells.push(null);
  for (let d = 1; d <= daysInMonth; d++) calendarCells.push(d);
  while (calendarCells.length % 7 !== 0) calendarCells.push(null);

  // 서울 타임존으로 현재 날짜 가져오기
  const seoulToday = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Seoul' }));

  // 디버깅용: endDates 배열 출력
  //console.log('endDates:', endDates);
  //const dateKey = `${selectedYear}-${String(selectedMonth+1).padStart(2,'0')}-${String(selectedDate.getDate()).padStart(2,'0')}`;
  let recordList = bookMap.get(selectedDate.getDate()) || [];

  return (
    <>
    <Wrapper>
      <Header>
        <HeaderLeft>
          <YearMonthSelect>
            <YearMonthRow>
              <ArrowBtn onClick={
                () => onMonthSelectBtnClick(LeftArrow)
              }>
                <IoChevronBack size={18} />
              </ArrowBtn>
              <YearMonthBtn onClick={() => {
                setTempSelectedYear(selectedYear);
                setTempSelectedMonth(selectedMonth);
                setShowYearMonthPicker(true);
              }}>{selectedYear}. {selectedMonth+1}</YearMonthBtn>
              <ArrowBtn onClick={
                () => onMonthSelectBtnClick(RightArrow)
              }>
                <IoChevronForward size={18} />
              </ArrowBtn>
            </YearMonthRow>
          </YearMonthSelect>
          <ViewTypeSelect>
            <ViewTypeSelectBox 
              value={viewType} 
              onChange={(e) => setViewType(Number(e.target.value))}
            >
              <option value={ViewType.ViewEndDate}>마감일로 보기</option>
              <option value={ViewType.ViewAll}>전체일정보기</option> 
            </ViewTypeSelectBox>
          </ViewTypeSelect>
        </HeaderLeft>
        <TabToggle>
          <TabBtn active={selectedTab===Noobook} onClick={()=>onTabBtnClick(Noobook)}>누북</TabBtn>
          <TabBtn active={selectedTab===Noopill} onClick={()=>onTabBtnClick(Noopill)}>누필</TabBtn>
        </TabToggle>
      </Header>
      <CalendarBox>
        <DaysRow>
          {daysKor.map((d, i) => (
            <DayName key={d} sunday={i===0}>{d}</DayName>
          ))}
        </DaysRow>
        <DatesGrid>
          {calendarCells.map((d, i) => {
            const isToday = d === seoulToday.getDate() && selectedMonth === seoulToday.getMonth() && selectedYear === seoulToday.getFullYear();
            const isSelected = d === selectedDate.getDate();
            const hasRecord = typeof d === 'number' && bookMap.get(d) !== undefined;
            if (d === 7) {
              console.log('7일 hasRecord:', hasRecord);
            }
            return (
              <DateCell key={i} onClick={()=>d && setSelectedDate(new Date(selectedYear, selectedMonth, d))}>
                {d ? (
                  <DateCircle selected={isSelected} today={isToday}>
                    {d}
                    {hasRecord && <EndDateDot />}
                  </DateCircle>
                ) : null}
              </DateCell>
            );
          })}
        </DatesGrid>
      </CalendarBox>
      <RecordListBox>
        <RecordListHeader>
          <span style={{fontWeight:700, fontSize:20}}>{selectedDate.getDate()}. {daysKor[selectedDate.getDay()]}</span>
        </RecordListHeader>
        {recordList.length === 0 ? (
          <EmptyRecordMessage>일정이 없습니다.</EmptyRecordMessage>
        ) : (
          recordList.map((book, idx) => (
            <BookRow key={book.id} onClick={()=>/*navigate(`/book/${book.bookId}`)*/popupBookDetail(book.bookId)}>
              <BookCoverImage
                src={book.cover}
                alt={book.title}
                width={60}
                height={84}
                borderRadius={8}
                boxShadow="none"
                fontSize={9}
              />
              <BookInfo>
                <BookTitle>{book.title}</BookTitle>
                <BookMeta>{book.author} / {book.publisher}</BookMeta>
                <BookPeriod>{selectedTab===Noobook ? (stringFrDate(book?.readFr??'', 'yyyy-MM-dd', '-') + ' ~ ' + stringFrDate(book?.readTo??'', 'yyyy-MM-dd', '-')) : (stringFrDate(book?.scriptFr??'', 'yyyy-MM-dd', '-') + ' ~ ' + stringFrDate(book?.scriptTo??'', 'yyyy-MM-dd', '-'))}</BookPeriod>
              </BookInfo>
              <MemoBox>
                <PencilSquareIcon style={{width:28, height:28, color:'#bdbdbd'}} />
                <MemoText>메모 <span style={{color:'#2346a9', fontWeight:700}}>{memoCntMap.get(book.id)??0}장</span></MemoText>
              </MemoBox>
            </BookRow>
          ))
        )}
      </RecordListBox>
    </Wrapper>
    {loading && <LoadingOverlay isLoading={loading} />}
    {showBookDetailModal && (
      <BookDetailModal bookId={selBookId} onClose={()=>handleBookDetailClose(isBookDetailModified)} selectedTab={selectedTab} onModified={handleBookDetailModified} />
    )}
    {showYearMonthPicker && (
      <YearMonthPickerOverlay onClick={(e) => {
        if (e.target === e.currentTarget) setShowYearMonthPicker(false);
      }}>
        <YearMonthPickerModal onClick={(e) => e.stopPropagation()}>
          <YearMonthPickerHeader>
            <div></div>
            <YearMonthPickerButton onClick={() => {
              setSelectedYear(tempSelectedYear);
              setSelectedMonth(tempSelectedMonth);
              setSelectedDate(new Date(tempSelectedYear, tempSelectedMonth, 1));
              setShowYearMonthPicker(false);
            }}>완료</YearMonthPickerButton>
          </YearMonthPickerHeader>
          <YearMonthPickerContent>
            <YearColumn>
              {Array.from({ length: 11 }, (_, i) => {
                const year = new Date().getFullYear() - 5 + i;
                const isSelected = year === tempSelectedYear;
                return (
                  <YearMonthItem
                    key={year}
                    ref={el => yearRefs.current[year] = el}
                    selected={isSelected}
                    onClick={() => setTempSelectedYear(year)}
                  >
                    {year}
                  </YearMonthItem>
                );
              })}
            </YearColumn>
            <MonthColumn>
              {Array.from({ length: 12 }, (_, i) => {
                const isSelected = i === tempSelectedMonth;
                return (
                  <YearMonthItem
                    key={i}
                    ref={el => monthRefs.current[i] = el}
                    selected={isSelected}
                    onClick={() => setTempSelectedMonth(i)}
                  >
                    {i + 1}월
                  </YearMonthItem>
                );
              })}
            </MonthColumn>
          </YearMonthPickerContent>
        </YearMonthPickerModal>
      </YearMonthPickerOverlay>
    )}
    </>
  );
}

// styled-components
const Wrapper = styled.div`
  min-height: 100vh;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 20px 0 20px;
  background: #eae8e9;
`;
const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
const YearMonthSelect = styled.div``;
const ViewTypeSelect = styled.div`
  display: flex;
  align-items: center;
`;
const ViewTypeSelectBox = styled.select`
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 8px 6px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  outline: none;
  
  &:focus {
    border-color: #0057ff;
  }
`;
const YearMonthRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ArrowBtn = styled.button`
  background: none;
  border: none;
  padding: 0 4px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #bdbdbd;
  font-size: 20px;
`;
const YearMonthBtn = styled.button`
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  cursor: pointer;
`;
const TabToggle = styled.div`
  display: flex;
  gap: 4px;
`;
const TabBtn = styled.button`
  background: ${({active})=>active ? '#222' : '#bdbdbd'};
  color: ${({active})=>active ? '#fff' : '#fff'};
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 8px;
  cursor: pointer;
`;
const CalendarBox = styled.div`
  background: #eae8e9;
  margin: 0 20px 10px 20px;
  padding: 16px 0 10px 0;
`;
const DaysRow = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 0 24px;
`;
const DayName = styled.div`
  font-size: 16px;
  color: ${({sunday})=>sunday ? '#e23a3a' : '#888'};
  font-weight: 500;
  text-align: center;
  width: 40px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const DatesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 6px 0;
  padding: 0 24px;
`;
const DateCell = styled.div`
  text-align: center;
  height: 44px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  margin: 0 auto;
`;
const DateCircle = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 18px;
  font-weight: 500;
  background: ${({selected})=>selected ? '#0057ff' : 'transparent'};
  color: ${({selected})=>selected ? '#fff' : '#7d7d7d'};
  position: relative;
`;
const EndDateDot = styled.div`
  position: absolute;
  left: 50%;
  bottom: 2px;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  background: #0057ff;
  border-radius: 50%;
`;
const RecordListBox = styled.div`
  background: #fff;
  padding: 18px 20px 40px 20px;
  flex: 1;
  min-height: 0;
`;
const RecordListHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0 24px 12px 24px;
`;
const BookRow = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 24px 8px 24px;
  border-bottom: 1px solid #f0f0f0;
  &:last-child { border-bottom: none; }
`;
const BookInfo = styled.div`
  flex: 1;
  min-width: 0;
  margin-left: 18px;
`;
const BookTitle = styled.div`
  font-size: 19px;
  font-weight: 700;
  color: #222;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const BookMeta = styled.div`
  font-size: 15px;
  color: #bdbdbd;
  margin-bottom: 2px;
`;
const BookPeriod = styled.div`
  font-size: 15px;
  color: #888;
`;
const MemoBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 18px;
`;
const MemoText = styled.div`
  font-size: 16px;
  color: #888;
  margin-top: 2px;
`;

const EmptyRecordMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  color: #888;
  font-size: 16px;
  text-align: center;
`;

const YearMonthPickerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

const YearMonthPickerModal = styled.div`
  background: #fff;
  width: 100%;
  max-width: 480px;
  border-radius: 20px 20px 0 0;
  padding-bottom: 20px;
  max-height: 30vh;
  display: flex;
  flex-direction: column;
`;

const YearMonthPickerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
`;

const YearMonthPickerButton = styled.button`
  background: none;
  border: none;
  color: #e23a3a;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
`;

const YearMonthPickerContent = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  height: 150px;
`;

const YearColumn = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
`;

const MonthColumn = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
  border-left: 1px solid #eee;
`;

const YearMonthItem = styled.div`
  font-size: ${({ selected }) => selected ? '24px' : '16px'};
  font-weight: ${({ selected }) => selected ? '700' : '400'};
  color: ${({ selected }) => selected ? '#222' : '#999'};
  padding: 12px 20px;
  cursor: pointer;
  text-align: center;
  width: 100%;
  position: relative;
  transition: all 0.2s;
  
  ${({ selected }) => selected && `
    &::before {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 120%;
      height: 100%;
      background: #f5f5f5;
      z-index: -1;
      border-radius: 8px;
    }
  `}
`; 